module.exports = __webpack_public_path__ + "img/appltAliRGuide-4.8ad536fa.png";